export class HrOrgPosCardsRouterConstants {
    public static readonly ORG_LIST = '/humanresources/personnel/organization/object-management/organization-management/organization-tree';
    public static readonly POS_LIST = '/humanresources/personnel/position-management';
    public static readonly ORG_CARDS_MAIN
        = '/humanresources/personnel/organization/object-management/organization-management/organization-cards/cards';
    public static readonly POS_CARDS_MAIN = '/humanresources/personnel/position-management/position-cards/cards';

    private constructor() {}
}
